// HourlySalaryCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Upah Per Jam - Hitung Upah Per Jam Kerja";
const DESCRIPTION =
  "Hitung upah per jam berdasarkan gaji bulanan Anda dan jumlah jam kerja harian. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui berapa penghasilan Anda per jam.";
const KEYWORDS = "kalkulator, gaji, upah, jam, kerja, hitung, bulanan";
const OG_URL =
  "https://do-calculate.com/calculator/id/hourly-salary-calculator/";
function HourlySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [dailyWorkHours, setDailyWorkHours] = useState("0");
  const [hourlyRate, setHourlyRate] = useState(null);
  const [error, setError] = useState("");
  const calculateHourlyRate = () => {
    try {
      if (monthlySalary === "0" && dailyWorkHours === "0") {
        setError("Harap masukkan gaji dan jam kerja yang valid untuk menghitung upah per jam");
        return;
      }
      const workDaysPerMonth = 22;
      const totalWorkHours = dailyWorkHours * workDaysPerMonth;
      const hourlyWage = monthlySalary / totalWorkHours;
      setHourlyRate(hourlyWage);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara mudah untuk mengetahui upah yang Anda peroleh per jam berdasarkan gaji bulanan Anda dan jumlah jam kerja harian. Mengetahui upah per jam penting untuk lebih memahami nilai waktu Anda, baik Anda sedang mempertimbangkan negosiasi gaji atau merencanakan pekerjaan tambahan. Kalkulator ini berguna bagi orang-orang yang bekerja dengan gaji bulanan dan ingin mengetahui bagaimana pendapatan mereka terdistribusi pada jam kerja harian.
                </p>
                <p>
                  Misalnya, jika Anda menerima gaji bulanan sebesar 5000 dan bekerja 8 jam per hari, Anda dapat menggunakan kalkulator ini untuk menentukan berapa penghasilan Anda per jam. Mengetahui detail ini dapat membantu Anda membuat keputusan keuangan yang lebih bijak dan dalam negosiasi upah yang lebih baik berdasarkan nilai waktu Anda yang sebenarnya.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="monthly-salary">Gaji Bulanan:</label>
                    <input
                      id="monthly-salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="daily-work-hours">
                      Jumlah Jam Kerja Harian:
                    </label>
                    <input
                      id="daily-work-hours"
                      type="number"
                      value={dailyWorkHours}
                      onChange={(e) => setDailyWorkHours(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateHourlyRate}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  hourlyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Upah Per Jam: {hourlyRate.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Upah Per Jam</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Menentukan Gaji Bulanan
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda perlu mengetahui gaji bulanan yang Anda terima. Ini harus mencakup semua tunjangan dan kompensasi yang Anda terima setiap bulan. Memasukkan gaji bulanan dengan akurat adalah langkah pertama menuju perhitungan upah per jam yang benar. Ingat bahwa gaji bulanan adalah dasar yang akan Anda gunakan untuk perhitungan selanjutnya.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Menentukan Jumlah Jam Kerja Harian
                    </h2>
                  </u>
                  <p>
                    Setelah menentukan gaji bulanan, Anda harus memasukkan jumlah jam kerja harian. Jam kerja harian mewakili durasi yang Anda habiskan untuk bekerja setiap hari. Jam kerja dapat bervariasi dari hari ke hari, tetapi Anda harus memasukkan jumlah rata-rata jam yang Anda kerjakan setiap hari. Informasi ini penting untuk menghitung jumlah jam kerja bulanan dan selanjutnya menghitung upah per jam.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Menghitung Upah Per Jam
                    </h2>
                  </u>
                  <p>
                    Setelah memasukkan gaji bulanan dan jumlah jam kerja harian, Anda sekarang dapat menghitung upah per jam. Untuk melakukannya, hitung jumlah jam kerja bulanan dengan mengalikan jumlah jam kerja harian dengan jumlah hari kerja dalam sebulan, yang biasanya 22 hari. Setelah itu, bagi gaji bulanan dengan jumlah jam kerja bulanan untuk mendapatkan upah per jam. Perhitungan ini akan memberikan nilai yang tepat untuk upah yang Anda peroleh per jam.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika gaji bulanan Anda 5000 dan jumlah jam kerja harian 8 jam, maka upah per jam akan sekitar 28.41.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Menggunakan Upah Per Jam dalam Perencanaan Keuangan
                    </h2>
                  </u>
                  <p>
                    Setelah mengetahui upah per jam, Anda dapat menggunakan informasi ini dalam perencanaan keuangan Anda. Misalnya, jika Anda mempertimbangkan untuk menambah jam kerja atau bekerja di pekerjaan tambahan, mengetahui upah per jam membantu Anda membuat keputusan yang tepat. Perhitungan ini juga dapat membantu Anda dalam negosiasi gaji yang lebih baik berdasarkan nilai waktu Anda.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika Anda berencana bekerja 4 jam tambahan setiap hari, Anda dapat menghitung jumlah gaji tambahan yang akan Anda peroleh berdasarkan upah per jam.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HourlySalaryCalculator;